import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

type Props = ClassAttributes<HTMLElement> & {
  size?: number;
  color?: string;
  className?: string;
};

const KaizenPointIcon = ({ size = 20, color = 'currentColor', className }: Props) => (
  <Root
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 20 20"
    width={size}
    height={size}
    className={className}
  >
    <defs />
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="kaizenpoint" transform="translate(-2.000000, -2.000000)">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
        <path
          d="M12,2 C17.52,2 22,6.48 22,12 C22,17.52 17.52,22 12,22 C6.48,22 2,17.52 2,12 C2,6.48 6.48,2 12,2 Z M12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 Z M12.439,7.5 C13.245004,7.5 13.9448304,7.63433199 14.5385,7.903 C15.1321696,8.17166801 15.5893317,8.55299753 15.91,9.047 C16.2306683,9.54100247 16.391,10.1259966 16.391,10.802 C16.391,11.4693367 16.2306683,12.0521642 15.91,12.5505 C15.5893317,13.0488358 15.1321696,13.4301653 14.5385,13.6945 C13.9448304,13.9588347 13.245004,14.091 12.439,14.091 L10.606,14.091 L10.606,16.6 L8.5,16.6 L8.5,7.5 L12.439,7.5 Z M12.322,12.375 C12.9546698,12.375 13.435665,12.2385014 13.765,11.9655 C14.094335,11.6924986 14.259,11.3046692 14.259,10.802 C14.259,10.2906641 14.094335,9.89850137 13.765,9.6255 C13.435665,9.35249863 12.9546698,9.216 12.322,9.216 L10.606,9.216 L10.606,12.375 L12.322,12.375 Z M12,19 C15.8659932,19 19,15.8659932 19,12 C19,8.13400675 15.8659932,5 12,5 C8.13400675,5 5,8.13400675 5,12 C5,15.8659932 8.13400675,19 12,19 Z"
          id="Combined-Shape"
          fill={color}
          fillRule="nonzero"
        />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default KaizenPointIcon;
